import React from 'react';

import Background from '../../resources/img/header_bg.jpg';

const styles = {
    headerImage: {
        backgroundImage: `url(${Background})`,
        backgroundSize: '1000px 400px',       
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: 200,
        width: '100%',
    },
    headerContainer:{
        // position: 'fixed',
        top: 0,
        left:0,
        width: "100%",
        background: 'black',
        zIndex: 1
    }


}

const Header = () => {
    return (
        <div id="background-container" style ={styles.headerContainer}>
              <div style={styles.headerImage}>
                
                </div>
        </div>
      
    );
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js